import React from 'react';
import './style.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import citrusFruit from '../../assets/citrus-fruit.png';

export function Checkin() {
    const navigate = useNavigate();
    const [name, setName] = React.useState();
    const [count, setCount] = React.useState(1);
    const [kids, setKids] = React.useState(0);
    const [veggie, setVeggies] = React.useState(0);
    const [dessert, setDessert] = React.useState();
    const [remark, setRemark] = React.useState();
    const [phoneNumber, setPhoneNumber] = React.useState();
    const [checkedin, setCheckedIn] = React.useState<boolean>();
    const [buttonDisabled, setButtonDisabled] = React.useState<boolean>(true);

    function enableButton() {
        if (name && count && kids && veggie && phoneNumber) {
            setButtonDisabled(false);
        }
    }

    function handleName(event: any) {
        setName(event.target.value);
        enableButton();
    }

    function handleCount(event: any) {
        setCount(event.target.value);
        enableButton();
    }

    function handleKids(event: any) {
        setKids(event.target.value);
        enableButton();
    }

    function handleVeggies(event: any) {
        setVeggies(event.target.value);
        enableButton();
    }

    function handleDessert(event: any) {
        setDessert(event.target.value);
        enableButton();
    }

    function handleRemark(event: any) {
        setRemark(event.target.value);
        enableButton();
    }

    function handlePhoneNumber(event: any) {
        setPhoneNumber(event.target.value);
        enableButton();
    }

    async function handleSumbit(event: any) {
        console.log({
            name: name,
            count: count,
            kids: kids,
            veggie: veggie,
            dessert: dessert,
            remark: remark,
            phoneNumber: phoneNumber
        });

        setButtonDisabled(true);

        const res = await axios.post(
            `/wedding/api/guests`,
            JSON.stringify({
                name: name,
                count: count,
                kids: kids,
                veggie: veggie,
                dessert: dessert,
                remark: remark,
                phoneNumber: phoneNumber
            }),
            {
                // Environment variable for local?
                baseURL: `https://wir-heiraten.wiedicke.com`,
                headers: {
                    Accept: '/',
                    'Content-Type': 'application/json'
                }
            }
        );

        if (res.status === 200) {
            console.log('Response success');
            setTimeout(() => {
                setCheckedIn(true);
            }, 1000);
        }
    }

    if (!checkedin) {
        return (
            <div id="checkin-screen">
                <div className="checkin-container">
                    <div className="checkin-header-container">
                        <div className="checkin-header-content">Schön, dass du dabei bist!</div>
                    </div>
                    <div className="checkin-form-container">
                        <div className="checkin-form-row">
                            <div className="checkin-form-field">NAME (*)</div>
                            <div className="checkin-form-input">
                                <input
                                    className="checkin-form-input-input"
                                    type="string"
                                    value={name}
                                    onChange={handleName}
                                    style={{
                                        borderRadius: '12px',
                                        border: '1px solid #dfe1e5'
                                    }}
                                ></input>
                            </div>
                        </div>
                        <div className="checkin-form-row-container">
                            <div className="checkin-form-row">
                                <div className="checkin-form-field">ANZAHL (*)</div>
                                <div className="checkin-form-input">
                                    <select value={count} onChange={handleCount}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                    </select>
                                </div>
                            </div>
                            <div className="checkin-form-row">
                                <div className="checkin-form-field">KINDER (*)</div>
                                <div className="checkin-form-input">
                                    <div className="checkin-form-input">
                                        <select value={kids} onChange={handleKids}>
                                            <option value="0">0</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="checkin-form-row">
                                <div className="checkin-form-field">VEGGIE (*)</div>
                                <div className="checkin-form-input">
                                    <div className="checkin-form-input">
                                        <select value={veggie} onChange={handleVeggies}>
                                            <option value="0">0</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="checkin-form-row-container">
                            <div className="checkin-form-row">
                                <div className="checkin-form-field">ICH BRINGE EIN DESSERT MIT</div>
                                <div className="checkin-form-input">
                                    <textarea
                                        className="checkin-form-textarea-input"
                                        onChange={handleDessert}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="checkin-form-row-container">
                            <div className="checkin-form-row">
                                <div className="checkin-form-field">
                                    WEITERE ANMERKUNGEN <br />
                                    <div className="checkin-form-field-attribute">(UNVERTRÄGLICHKEITEN O.Ä.)</div>
                                </div>
                                <div className="checkin-form-input">
                                    <div className="checkin-form-input">
                                        <textarea
                                            className="checkin-form-textarea-input"
                                            onChange={handleRemark}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="checkin-form-row-container">
                            <div className="checkin-form-row">
                                <div className="checkin-form-field">
                                    TELEFONNUMMER (*) <br />
                                </div>
                                <div className="checkin-form-input">
                                    <input
                                        className="checkin-form-input-input"
                                        type="number"
                                        value={phoneNumber}
                                        onChange={handlePhoneNumber}
                                        style={{ width: '100%' }}
                                    ></input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="checkin-submit-container">
                    <button
                        className={buttonDisabled ? 'calender-entry-button disabled' : 'calender-entry-button'}
                        onClick={handleSumbit}
                        disabled={buttonDisabled}
                    >
                        ABSCHICKEN
                    </button>
                </div>
            </div>
        );
    } else {
        return (
            <div id="checkedin-screen">
                <div className="checkedin-confirmation-container">
                    <div className="checkedin-confirmation-icon-container">
                        <img alt="Herz" src={citrusFruit} className="fingerprint-image" />
                    </div>
                    <div className="checkedin-confirmation-text-container">
                        <div className="checkedin-confirmation-text">Wir freuen uns auf dich! ☺️</div>
                    </div>
                    <div className="checkedin-button-container">
                        <button className="accept-button" onClick={() => navigate('/')}>
                            BEENDEN
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
